module.exports = __webpack_public_path__ + "img/setebos.550b3bc7.png";